import {Form, Formik} from "formik";
import React from "react";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import Checkbox from "@mui/material/Checkbox";
import {FormControlLabel} from "@material-ui/core";
import {IDictionary} from "../ExternalControl/ExternalControlContainer";

export interface IKind extends IDictionary {
}

type Props = {
  handleNewKind(e: React.MouseEvent): void;
  handleChangeKind(kind: IKind, checked: boolean): Promise<void>;
  data: IKind[];
};

export const KindListForm: React.FC<Props> = ({
  handleNewKind,
  handleChangeKind,
  data,
}) => {

  return (
    <Formik
      enableReinitialize={true}
      onSubmit={(values) => {}}
      initialValues={{}}
    >
      {({ handleChange, values }) => {
        return (
          <Form>
            <List>
              {data?.map((kind: IKind) => {
                const labelId = `checkbox-list-secondary-label-${kind.entryId}`;
                return (
                  <div key={kind.entryId} className='two-column'>
                    <ListItem>
                      <FormControlLabel
                        label={kind.description}
                        control={
                          <Checkbox
                            id={kind.abbrev}
                            name={kind.abbrev}
                            checked={kind.active}
                            onChange={(e) => {
                              handleChangeKind(kind, e.target.checked);
                            }}
                            inputProps={{ "aria-labelledby": labelId }}
                          />
                        }
                      />
                    </ListItem>
                  </div>
                );
              })}
              <div key='button-add' className='two-column'>
                <ListItem>
                  <button
                    type='button'
                    className='btn save-btn'
                    onClick={handleNewKind}
                  >
                    + DODAJ NOWY <span className="sr-only">rodzaj kontroli</span>
                  </button>
                </ListItem>
              </div>
            </List>
          </Form>
        );
      }}
    </Formik>
  );
};
